var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-box"},[_c('ul',_vm._l((_vm.navList),function(item,idx){return _c('li',{key:item.title,class:{
        'bgc-actived': _vm.currentIdx == idx,
      },on:{"click":function($event){return _vm.clickToggleScene(item, idx)}}},[_c('div',{staticClass:"border-box"},[_c('div',[_c('i',{class:['iconfont', item.icon]}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.title))])]),_c('div',{class:{'border-actived':_vm.currentIdx == idx}})])])}),0),_c('Pano')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }